import { StandardEvents } from '@shopify/events';

/**
 * S&S, audit plan 2026-10-18 step 2. Wraps server rendered text that depends on the selected variant
 * (the price line and the store proof line on product pages). Horizon only morphs the variant picker
 * and <product-price> on a variant change, so this element listens for the same product select event
 * that product-price.js uses and replaces its own markup with the matching element from the fetched page.
 */
class SsVariantText extends HTMLElement {
  connectedCallback() {
    this.section = this.closest('.shopify-section, dialog');
    if (!this.section) return;
    this.section.addEventListener(StandardEvents.productSelect, this.handleProductSelect);
  }

  disconnectedCallback() {
    this.section?.removeEventListener(StandardEvents.productSelect, this.handleProductSelect);
  }

  handleProductSelect = (event) => {
    if (!(event.target instanceof Element) || event.target.closest('product-card')) return;
    event.promise
      .then(({ detail }) => {
        if (!detail?.html) return;
        if (!detail.newProduct && detail.productId && detail.productId !== this.dataset.productId) return;
        const key = this.dataset.ssKey;
        const next = detail.html.querySelector(`ss-variant-text[data-ss-key="${key}"]`);
        if (!next) return;
        this.innerHTML = next.innerHTML;
        if (next.dataset.productId) this.dataset.productId = next.dataset.productId;
      })
      .catch((error) => {
        if (error?.name !== 'AbortError') console.warn('[ss-variant-text] Event promise rejected:', error);
      });
  };
}

if (!customElements.get('ss-variant-text')) {
  customElements.define('ss-variant-text', SsVariantText);
}
